module.exports = __webpack_public_path__ + "assets/img/top-img@2x.af50ffbd.jpg";